export default __webpack_public_path__ + "static/media/globe.afe88b13.svg";